import { render, staticRenderFns } from "./MyOrderAdmin.vue?vue&type=template&id=6a4a56ec&scoped=true"
import script from "./MyOrderAdmin.vue?vue&type=script&lang=js"
export * from "./MyOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./MyOrderAdmin.vue?vue&type=style&index=0&id=6a4a56ec&prod&lang=css"
import style1 from "./MyOrderAdmin.vue?vue&type=style&index=1&id=6a4a56ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a56ec",
  null
  
)

export default component.exports